import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnnotate = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.5,
	clipRule: "evenodd",
	viewBox: "0 0 200 200",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.82,
			d: "M1465.74 220.724c-5.86-1.11-6.55-8.762-12.31-2.334-10.82 12.095-10.8 18.401-4.52 26.659 1.69 2.214 4.96-.155 6.43-1.802 2.01-2.256 2.89-5.3 5.05-7.44 2.89-2.872 7.61-2.979 10.38-5.881 4.61-4.837.53-9.227-5.02-9.373",
			transform: "matrix(.00537 -1.07054 1.12731 .00566 -191.769 1688.027)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9960335999999999,
			d: "M104.9 76.814c.398-.923-5.33 11.138-6.577 13.665-4.4 8.878-9.753 17.057-14.789 25.565-2.347 3.97-1.837 4.357-2.506 8.606-.238 1.558-.783 4.664-.783 4.664s1.633-3.04 2.597-4.465c2.02-2.985 3.947-5.964 5.592-9.208 4.967-9.837 10.365-19.38 15.707-29.025 2.12-3.843 4.967-7.857 5.943-12.212.295-1.342-3.38-.934-4.128-.105"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.9960335999999999,
			d: "M105.23 75.753c.011-.42.25-1.255.782-1.301.556-.05-.93 1.184-.544 1.597 1.871 2.025 3.414 1.951 1.849 4.268-.284.429-.613 1.187-1.078 1.454-1.077.63-6.907-3.31-1.78-5.572"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 1.9960335999999999,
			d: "M82.128 124.833c.227-.088-.216.01-.34.259"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2.0002064,
			d: "M130.098 51.813c3.011 3.607.555 15.316-3.63 15.224-9.312-.205-10.486-21.173 3.63-15.224"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.72,
			d: "M571.443 617.351c-2.923-9.317 20.687-19.504 15.596-2.321-.469 1.583-6.339-7.946-11.577-4.975",
			transform: "matrix(-1.05441 -.6134 -.55365 .95172 1077.113 -171.698)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2.0002064,
			d: "M125.457 68.337c2.587-.53 5.239-2.907 8.596-1.027 2.076 1.162 3.3 5.592 3.487 6.58.797 4.243.804 5.405 1.31 9.36.865 6.783.884 24.357 1.366 31.177.124 1.742 1.157 6.437-.288 7.882-.494.494-1.73.044-2.27-.064-2.328-.466-4.681-.55-7.05-.496-1.974.045-3.95.266-5.883.672-.42.088-2.026.674-2.462.383-.443-.295-.46-1.924-.512-2.35-.352-2.869.311-5.848.096-8.728-.745-9.966.296-23.399 2.143-32.931"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 3.44,
			d: "M556.389 705.752c-.013-.005.154 2.605.168 2.751a138 138 0 0 0 .556 4.755c.635 4.821 1.138 9.663 1.568 14.507 1.232 13.846 1.498 27.755 2.897 41.589M576.029 703.988c-.098.007-.017 5.775-.017 5.939 0 3.865-.205 7.705-.458 11.562-1.075 16.38-3.502 32.945-2.679 49.386",
			transform: "matrix(-.66232 0 0 .48792 506.203 -221.753)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2.0002064,
			d: "M134.121 156.235c1.138-1.206-1.171-3.644-2.258-3.954-2.658-.76-3.682 3.295-3.374 5.147.05.292.118.272 0 0-.28-.646-.681-1.242-1.118-1.79-1.06-1.33-3.092-3.958-5.1-3.086-1.111.483-3.302 5.473-1.583 5.5 5.983.093 8.733-.184 12.714-.262M125.998 68.233c-.717 0-1.53.64-2.036 1.088-1.613 1.432-6.655 8.004-8.162 9.511M115.8 78.832c.079-.231-.595.68-.731.827-.474.513-.985 1.172-1.707 1.332-1.475.328-4.086-.782-5.61-1.004M123.58 81.051c-1.188 1.01-6.202 6.296-7.92 6.778-1.923.54-7.378-4.202-9.001-5.013M131.143 78.795s1.265 20.573 0 23.446 6.473 1.126 6.473 1.126 2.44-8.473 1.822-11.525"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2.0002064,
			d: "M133.093 103.893s-3.005.86-2.09 2.622c.916 1.763 1.546 4.67 2.776 2.251s1.492-4.873 1.492-4.873"
		})
	]
});
export default SvgAnnotate;
